export default "__VITE_PUBLIC_ASSET__a557ed4f__"